import { useAtomValue } from 'jotai';
import { callSettingsAtom, DEFAULT_CALL_THRESHOLDS } from '@/lib/atoms';

interface PhoneCallTimerProps {
  elapsedSeconds: number;
  className?: string;
}

function formatTime(seconds: number): string {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  if (hrs > 0) return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
  return `${pad(mins)}:${pad(secs)}`;
}

function getTimerColor(elapsedSeconds: number, thresholds: Array<{ minutes: number; color: string }>): string {
  const elapsedMinutes = elapsedSeconds / 60;
  const sorted = [...thresholds].sort((a, b) => b.minutes - a.minutes);
  for (const t of sorted) {
    if (elapsedMinutes >= t.minutes) return t.color;
  }
  return thresholds[0]?.color || '#22c55e';
}

export function PhoneCallTimer({ elapsedSeconds, className }: PhoneCallTimerProps) {
  const thresholds = useAtomValue(callSettingsAtom);
  const activeThresholds = thresholds.length > 0 ? thresholds : DEFAULT_CALL_THRESHOLDS;
  const color = getTimerColor(elapsedSeconds, activeThresholds);

  return (
    <span className={className} style={{ color, fontVariantNumeric: 'tabular-nums' }}>
      {formatTime(elapsedSeconds)}
    </span>
  );
}
